<template>
    <div class="list-wrap">
        <div class="list" v-for="(item, index) in list" :key="index">
            <div class="list-t">
                <div class="list-t-l">
                    <img :src="item.image" alt="">
                </div>
                <div class="list-t-c">
                    <h1 class="list-t-c-h1">{{item.title}}</h1>
                    <p class="list-t-c-p">开通/到期时间: {{ item.time_desc }}</p>
                    <h2 class="list-t-c-h2">{{ item.have_time }}</h2>
                </div>
                <div class="list-t-r">
                    <button @click.stop.prevent="get_company_wap(item.l_id)">再次{{item.have_time.indexOf("已过期") > -1? '开通': '续费'}}</button>
                </div>
            </div>
            <div class="list-b">
                <p><span @click.stop.prevent="jumpTo(item.l_id)">查看TA的个人主页</span></p>
            </div>
        </div>

        <div class="empty" v-if="list.length == 0 && !hasMore">
            <img src="https://cdncos.aigupiao.com/assets/jf/img/empty_icon.png" alt="">
            <p>您当前未开通会员</p>
        </div>
    </div>
</template>
<script>
    import goldApi from '@/api/gold/index.js'
    import circleApi from "@/api/circle/index.js";
    import { Toast } from 'vant';

    export default {
        name: "my-buy",
        data() {
            return {
                isLoading: false,
                hasMore: true,
                list: [],
                compare_to: 0
            }
        },
        computed: {
            userAvatar() {
                return this.$store.state.user.avatarImgPath
            },
            userId() {
                return this.$store.state.user.userId
            }
        },
        created() {
        },
        watch: {
            "$store.state.user": {
                immediate: true,
                deep: true,
                handler(val) {
                    console.info(val.userId,'val')
                    if(val.userId) {
                        this.getList();
                    }
                },
            },
        },
        methods: {
            async get_company_wap(l_id) {
                //jf 获取开通会员地址
                let res = await circleApi.get_company_wap({
                    live_id: l_id,
                    user_id: this.userId,
                    source:'wap',
                });
                // 跳转 jf 链接
                if(res.code == 1 && res.data && res.data.jump_url) {
                    location.href = res.data.jump_url;
                }
                else{
                    Toast({
                        type: "html",
                        message: "<div class='stockGroupTips'>暂不支持</div>",
                        position: "bottom"
                    })
                }
                
            },
            jumpTo(l_id) {
                let current = "";
                if(location.origin.indexOf("dev") > -1 || location.origin.indexOf("192.168.1") > -1) {
                    current = "dev"
                }
                window.location.href = `https://igp${current}.jfinfo.com/app_lives/center/id/${l_id}`
            },
            async getList() {
                this.isLoading = true;
                let params = {
                    appversion: "12.7.0",
                    u_id: this.userId,
                    user_id: this.userId,
                    type: "all"
                }
                let res = await goldApi.my_buy_vip(params);
                this.isLoading = false;
                if(res.rslt == "succ") {
                    if (res.info.length === 0) {
                        this.hasMore = false;
                    }
                    else{
                        this.list = this.list.concat(res.info);
                        this.compare_to = this.list[this.list.length-1].rec_time;
                    }
                }
                else {
                    this.hasMore = false;
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .list-wrap {
        min-height: 100vh;
    }

    .empty {
        width: 100%;
        height: auto;
        padding-top: 42px;

        img {
            width: 255px;
            height: auto;
            display: block;
            margin: 0 auto;
        }

        p {
            font-size: 20px;
            text-align: center;
            color: #939393;
        }
    }

    .list {
        width: 100%;
        height: auto;
        display: block;
        padding: 12px 12px 0;
        box-sizing: border-box;
        background-color: #fff;
        margin-bottom: 6px;

        .list-t {
            display: flex;
            flex-direction: row;
            align-items: center;

            .list-t-l {
                width: 55px;

                img {
                    width: 55px;
                    height: 55px;
                    border-radius: 50%;
                    overflow: hidden;
                    object-fit: cover;
                    display: block;
                }
            }

            .list-t-c {
                flex: 1;
                overflow: hidden;
                padding-left: 10px;
                box-sizing: border-box;
                margin-bottom: 10px;

                .list-t-c-h1 {
                    font-size: 15px;
                    line-height: 20px;
                    font-weight: bold;
                    color: #333;
                    margin-bottom: 6px;
                }

                .list-t-c-p {
                    font-size: 11px;
                    line-height: 18px;
                    color: #AFAFAF;
                    font-weight: 400;
                    margin-bottom: 6px;
                }

                .list-t-c-h2 {
                    font-size: 14px;
                    line-height: 20px;
                    color: #FF443D;
                    font-weight: 400;
                }
            }

            .list-t-r {

                button {
                     width: 65px;
                     height: 28px;
                     line-height: 28px;
                     border-radius: 4px;
                     border: 1px solid #FF443D;
                     background-color: transparent;
                     outline: none;
                     font-size: 13px;
                     color: #FF443D
                }
            }
        }

        .list-b {
            border-top: 0.5px solid #EBEBEB;
            height: 34px;
            line-height: 34px;

            p {
                text-align: center;

                span {
                    font-size: 12px;
                    line-height: 34px;
                    color: #939393;
                    font-weight: 400;
                    padding-right: 8.5px;
                    box-sizing: border-box;
                    background-image: url("https://cdncos.aigupiao.com/assets/jf/svg/my_buy_more_icon.svg");
                    background-repeat: no-repeat;
                    background-position-x: right;
                    background-position-y: center;
                    background-size: 4.5px 9px;
                }
            }
        }
    }
</style>